import { Component } from '@angular/core';
import { IconComponent } from '@copado/cds';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { HELP_DOCS_URL } from '@app/shared/help-docs-links.constants';

@Component({
  imports: [IconComponent, NgbTooltipModule, NgbDropdownModule],
  selector: 'app-help-block',
  styleUrls: ['./help-block.component.scss'],
  templateUrl: './help-block.component.html',
})
export class HelpBlockComponent {
  protected readonly HELP_DOCS_MAIN = HELP_DOCS_URL.MAIN;
}
